const CHANNEL_NAME = 'shippo-query-sync';

type QueryDataMessage = {
  data: unknown;
  queryKey: readonly unknown[];
  type: 'query-data';
};

let channel: BroadcastChannel | null | undefined;

const getChannel = (): BroadcastChannel | null => {
  if (channel !== undefined) return channel;

  channel = typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(CHANNEL_NAME);

  return channel;
};

/** Share freshly fetched query data with peer tabs. */
export const broadcastQueryData = (queryKey: readonly unknown[], data: unknown): void => {
  getChannel()?.postMessage({ data, queryKey, type: 'query-data' } satisfies QueryDataMessage);
};

/**
 * Subscribe to query data shared by peer tabs. Returns a cleanup function that
 * removes the listener.
 */
export const subscribeToQueryData = (
  onData: (queryKey: readonly unknown[], data: unknown) => void,
): (() => void) => {
  const ch = getChannel();
  if (!ch) return () => {};

  const handler = (event: MessageEvent<QueryDataMessage>) => {
    if (event.data?.type === 'query-data') onData(event.data.queryKey, event.data.data);
  };

  ch.addEventListener('message', handler);

  return () => ch.removeEventListener('message', handler);
};
